;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "PQgI46RFfV"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {

  let left = $(this).find('.lh-left .lh-item');
  let right = $(this).find('.lh-right .lh-item');

  let removeAllActive = function(items, contents ) {
    items.each( function(i) {
      let hasClass = this.classList.contains('active');
      if(hasClass) {
        this.classList.remove('active')
        contents[i].style.maxHeight = `0`
      }
    });
  }

  let eventAc = function(dom) {
    let heads = dom.find('.lh-head');
    let contents = dom.find('.lh-content');

    heads.each( function(i) {
      this.addEventListener('click', () => {
        let wrap = this.parentNode;
        let currentHasAc = wrap.classList.contains('active');
        if(!currentHasAc) {
          removeAllActive(dom, contents);
          wrap.classList.add('active');
          contents[i].style.maxHeight = `${contents[i].scrollHeight}px`
        } else {
          removeAllActive(dom, contents);
        }
      })
    })
  }
  eventAc(left);
  eventAc(right);

 };						cb.bind($('section[data-section-id="PQgI46RFfV"] include[data-name="style_2"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="PQgI46RFfV"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/zQBV8XqNDpendIr0/faq/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "wflvb5lcyat"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {

  let left = $(this).find('.lh-left .lh-item');
  let right = $(this).find('.lh-right .lh-item');

  let removeAllActive = function(items, contents ) {
    items.each( function(i) {
      let hasClass = this.classList.contains('active');
      if(hasClass) {
        this.classList.remove('active')
        contents[i].style.maxHeight = `0`
      }
    });
  }

  let eventAc = function(dom) {
    let heads = dom.find('.lh-head');
    let contents = dom.find('.lh-content');

    heads.each( function(i) {
      this.addEventListener('click', () => {
        let wrap = this.parentNode;
        let currentHasAc = wrap.classList.contains('active');
        if(!currentHasAc) {
          removeAllActive(dom, contents);
          wrap.classList.add('active');
          contents[i].style.maxHeight = `${contents[i].scrollHeight}px`
        } else {
          removeAllActive(dom, contents);
        }
      })
    })
  }
  eventAc(left);
  eventAc(right);

 };						cb.bind($('section[data-section-id="wflvb5lcyat"] include[data-name="style_2"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="wflvb5lcyat"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/zQBV8XqNDpendIr0/faq/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "ti5li4xn3na"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {

  let left = $(this).find('.lh-left .lh-item');
  let right = $(this).find('.lh-right .lh-item');

  let removeAllActive = function(items, contents ) {
    items.each( function(i) {
      let hasClass = this.classList.contains('active');
      if(hasClass) {
        this.classList.remove('active')
        contents[i].style.maxHeight = `0`
      }
    });
  }

  let eventAc = function(dom) {
    let heads = dom.find('.lh-head');
    let contents = dom.find('.lh-content');

    heads.each( function(i) {
      this.addEventListener('click', () => {
        let wrap = this.parentNode;
        let currentHasAc = wrap.classList.contains('active');
        if(!currentHasAc) {
          removeAllActive(dom, contents);
          wrap.classList.add('active');
          contents[i].style.maxHeight = `${contents[i].scrollHeight}px`
        } else {
          removeAllActive(dom, contents);
        }
      })
    })
  }
  eventAc(left);
  eventAc(right);

 };						cb.bind($('section[data-section-id="ti5li4xn3na"] include[data-name="style_2"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="ti5li4xn3na"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/zQBV8XqNDpendIr0/faq/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "6seztkz14le"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {

  let left = $(this).find('.lh-left .lh-item');
  let right = $(this).find('.lh-right .lh-item');

  let removeAllActive = function(items, contents ) {
    items.each( function(i) {
      let hasClass = this.classList.contains('active');
      if(hasClass) {
        this.classList.remove('active')
        contents[i].style.maxHeight = `0`
      }
    });
  }

  let eventAc = function(dom) {
    let heads = dom.find('.lh-head');
    let contents = dom.find('.lh-content');

    heads.each( function(i) {
      this.addEventListener('click', () => {
        let wrap = this.parentNode;
        let currentHasAc = wrap.classList.contains('active');
        if(!currentHasAc) {
          removeAllActive(dom, contents);
          wrap.classList.add('active');
          contents[i].style.maxHeight = `${contents[i].scrollHeight}px`
        } else {
          removeAllActive(dom, contents);
        }
      })
    })
  }
  eventAc(left);
  eventAc(right);

 };						cb.bind($('section[data-section-id="6seztkz14le"] include[data-name="style_2"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="6seztkz14le"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/zQBV8XqNDpendIr0/faq/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "ln4du3f8tqh"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {

  let left = $(this).find('.lh-left .lh-item');
  let right = $(this).find('.lh-right .lh-item');

  let removeAllActive = function(items, contents ) {
    items.each( function(i) {
      let hasClass = this.classList.contains('active');
      if(hasClass) {
        this.classList.remove('active')
        contents[i].style.maxHeight = `0`
      }
    });
  }

  let eventAc = function(dom) {
    let heads = dom.find('.lh-head');
    let contents = dom.find('.lh-content');

    heads.each( function(i) {
      this.addEventListener('click', () => {
        let wrap = this.parentNode;
        let currentHasAc = wrap.classList.contains('active');
        if(!currentHasAc) {
          removeAllActive(dom, contents);
          wrap.classList.add('active');
          contents[i].style.maxHeight = `${contents[i].scrollHeight}px`
        } else {
          removeAllActive(dom, contents);
        }
      })
    })
  }
  eventAc(left);
  eventAc(right);

 };						cb.bind($('section[data-section-id="ln4du3f8tqh"] include[data-name="style_2"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="ln4du3f8tqh"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/zQBV8XqNDpendIr0/faq/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "z92lnz6ed6s"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="z92lnz6ed6s"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/ZmHEruNeFAW5Gfd8/call-to-action/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');